import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import img1 from '../../assets/Images/RentADrone/Drone1.png'; // left
import img2 from '../../assets/Images/RentADrone/Drone2.png'; // right
import img3 from '../../assets/Images/RentADrone/Drone3.png'; // center
import img4 from '../../assets/Images/RentADrone/Drone4.png'; // bottom-left
import img5 from '../../assets/Images/RentADrone/image2_rentadrone.png'; // bottom-right
import './imagecollage.css';

const imageUrls = [
img1,img5,img4,img3,img2
];

const ImageCollage = () => {
  const [showSplit, setShowSplit] = useState(false);
  const [showImages, setShowImages] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplit(true);
    }, 1200);

    const imageTimer = setTimeout(() => {
      setShowImages(true);
    }, 2500); 

    return () => {
      clearTimeout(timer);
      clearTimeout(imageTimer);
    };
  }, []);

  return (
    <div className="drone-container">
      <div className="line-container">
        {/* <AnimatePresence>
          {!showSplit && (
            <motion.div
              className="full-line"
              initial={{ width: 0 }}
              animate={{ width: "80%" }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1.2 }}
            />
          )}
        </AnimatePresence> */}

        {showSplit && (
          <div className="split-line-wrapper">
            {[0, 1, 2, 3].map((i) => {
              const moveY = i === 1 ? 70 : i === 2 ? 159 : 0;
              const offsetX = [-30, -10, 10, 30];
              return (
                <motion.div
                  key={i}
                  className="split-piece"
                  initial={{ y: 0, opacity: 0, left: "50%" }}
                  animate={{ y: moveY, opacity: 1, left: `${40 + offsetX[i]}%` }}
                  transition={{
                    delay: 0.3 + i * 0.1,
                    duration: 0.5,
                    ease: "easeOut"
                  }}
                />
              );
            })}
          </div>
        )}

        {showImages && (
          <div className="image-container">
            {[0, 1, 2, 3,4].map((i) => {
              const moveY = i === 1 ? 70 : i === 2 ? 135 : 0;
              const offsetX = [-30, -10, 10, 30];
              const linePosition = 50 + offsetX[i];

              return (
                <motion.div
                  key={`image-${i}`}
                  className={`image-reveal${i}`}
                  initial={{ 
                    clipPath: 'inset(100% 0 0 0)',
                    opacity: 0
                  }}
                  animate={{ 
                    clipPath: 'inset(0% 0 0 0)',
                    opacity: 1
                  }}
                  transition={{
                    delay: 0.2 + i * 0.15,
                    duration: 0.8,
                    ease: "easeOut"
                  }}
                  style={{
                    position: 'absolute',
                    left: `${linePosition}%`,
                    bottom: `${0 - moveY}px`,
                    transform: 'translateX(-50%)'
                  }}
                >
                  <div className="placeholder-image">
                  <img 
                      src={imageUrls[i]} 
                      alt={`Image ${i + 1}`}
                      style={{ 
                        width: '100%', 
                        height: '100%', 
                        objectFit: 'cover',
                      }}
                    />
                  </div>
                </motion.div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageCollage;

// CSS styles
const styles = `
  .drone-container {
    width: 100%;
    background: #fff;
    position: relative;
    overflow: hidden;
  }

  .line-container {
    position: absolute;
    top: 60%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
  }
  
  /* Initial full line */
  .full-line {
    height: 4px;
    background: linear-gradient(to right, #ff7e00, #cc5500);
    margin: 0 auto;
    border-radius: 2px;
    position: relative;
  }
  
  /* Split line container — relative to center */
  .split-line-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
  }
  
  /* Individual split parts */
  .split-piece {
    position: absolute;
    top: 0;
    transform: translateX(-50%);
    width: 20%;
    height: 4px;
    background: linear-gradient(to right, #ff7e00, #cc5500);
    border-radius: 2px;
  }

  /* Image container */
  .image-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
  }

  /* Image reveal animation */
  .image-reveal {
    width: 200px;
    height: 150px;
    overflow: hidden;
  }

  /* Placeholder images */
  .placeholder-image {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 16px;
  }

  /* Responsive height for drone-container */
  /*
  @media (max-width: 767px) {
    .drone-container {
      height: 63rem;
    }
  }

  @media (min-width: 1024px) {
    .drone-container {
      padding: 1rem;
      height: 95rem;
  }
  
  @media (min-width: 1050px) {
    .drone-container {
      padding: 1rem;
      height: 85vh;
  }
  @media (min-width: 1680px) {
    .drone-container {
      padding: 1rem;
      height: 73vh;
  }
  @media (min-width: 2048px) {
    .drone-container {
      padding: 1rem;
      height: 68vh;
  }
  */
 @media (max-width: 768px) {
  .drone-container {
      height: 63ren;
    }
  }

  /* Laptop styles */
  @media (max-width: 1024px) {
    .drone-container {
      height: 63rem;
    }
  }

  /* Desktop large */
  @media (max-width: 1440px) {
    .drone-container {
      height: 50rem;
    }
  }

  /* Very wide monitors */
  @media (min-width: 1441px) {
    .drone-container {
      height: 44rem;
    }
  }

  /* Ultra-wide aspect-ratio adjustments */
  // @media (min-aspect-ratio: 16/9) {
  //   .drone-container {
  //     height: 103vh;
  //   }
  // }

  /* Retina / high pixel density */
  @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    .drone-container {
      height: 129vw;
        max-height: 44rem;
    }
  }
  .split-line-wrapper,
  .image-container {
    gap: clamp(6px, 2vw, 16px);
  }

  .image-reveal {
    width: clamp(100px, 35vw, 160px);
  }
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}
